import React from "react";

interface TabItem {
  id: string;
  label: string;
}

interface Props {
  tabs: TabItem[];
  activeTab: string;
  onChange: (tabId: string) => void;
}

const Tabs: React.FC<Props> = ({ tabs, activeTab, onChange }) => {
  return (
    <div className="analytics-tabs">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={`tab-btn ${activeTab === tab.id ? "active" : ""}`}
          onClick={() => onChange(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default Tabs;
